export const link = (label = "", link = "", type = "", icon = "", props) => ({
    label,
    link,
    type,
    icon,
    ...props,
});
